import {ajaxRequest} from "../common/Ajax";

export function popupCreateUpdateFleetServicesType(rowData = {}, confirmBtnText) {

    let popupTitle = 'Adaugă';
    let initValues = {}

    if (rowData?.name) {
        popupTitle = 'Editează'
        initValues = {
            name: rowData?.name,
            notify_before_km: rowData?.notify_before_km,
            notify_before_days: rowData?.notify_before_days,
            is_active: rowData?.is_active,
            is_expirable: rowData?.is_expirable,
        }
    }


    let inputIsExpirable = {
        type: 'checkbox',
        class: 'toggle'
    }

    let inputIsActive = {
        type: 'checkbox',
        class: 'toggle'
    }

    if(initValues?.is_expirable === '1') inputIsExpirable.checked = 'checked'
    if(initValues?.is_active === '1') inputIsActive.checked = 'checked'


    let fields = {
        'name': {
            label: {text: 'Denumire'},
            input: {type: 'text', value: initValues?.name ?? ''},
            field: {class: 'col-span-2'}
        },
        'is_expirable': {
            label: {text: 'Expirabil'},
            input: inputIsExpirable,
            field: {class: 'col-span-2 flex gap-2 items-center'}
        },
        'notify_before_km': {
            label: {text: 'Notificare (înainte cu km)'},
            input: {type: 'number', value: initValues?.notify_before_km},
            field: {class: 'form-control notify_before'}
        },
        'notify_before_days': {
            label: {text: 'Notificare (înainte cu zile)'},
            input: {type: 'number', value: initValues?.notify_before_days},
            field: {class: 'form-control notify_before'}
        },
        'is_active': {
            label: {
                text: ESR.lang.visibility
            },
            input: inputIsActive,
            field: {class: 'col-span-2 flex gap-2 items-center'}
        }
    };


    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-2 gap-4"></div>`);

    ESR.View.appendFields(popupContent, fields);


    //append from fields

    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            let data = ESR.View.getFieldsValues(fields);
            data.id = rowData?.id ?? 0;

            if (!data.name.length) {
                Swal.showValidationMessage('Completează denumirea');
                popupContent.find('#sw-input-name').focus();
                return;
            }

            return await ajaxRequest({action: "esr_update_fleet_service_type", data});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export default function tableSettingsFleetServicesType(HelperTable) {

    const selectorTable = '#table-fleet-services-type';
    const elTable = $(selectorTable)

    if (!elTable?.length) {
        return;
    }

    const tableData = Object.entries(ESR.fleet_services).map(item => item[1])


    const columns = [
        {
            label: 'ID',
            data: 'id',
            orderable: true
        },
        {
            label: 'Denumire',
            data: 'name',
            orderable: true
        },
        {
            label: 'Notificare (km)',
            data: 'notify_before_km',
            orderable: true
        },
        {
            label: 'Notificare (Zile)',
            data: 'notify_before_days',
            orderable: true
        },
        {
            label: 'Expirabil',
            data: 'is_expirable',
            render: function (data, type, row) {

                if (type === 'display') {
                    return row.is_expirable === '1' ? 'Da' : 'Nu';
                } else if (type === 'filter') {
                    return row.is_expirable;
                }
                return data;
            }
        },
        {
            label: ESR.lang.visibility,
            data: 'is_active',
            render: function (data, type, row) {

                if (type === 'display') {
                    return row.is_active === '1' ? ESR.lang.visible : ESR.lang.hidden;
                } else if (type === 'filter') {
                    return row.is_active;
                }
                return data;
            }
        },
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    const toolbar = HelperTable.createToolbarButtons({
        btnAdd: true,
        btnEdit: true,
        btnDelete: false,
    })

    let btnAdd = toolbar.find('.btn-row-add')
    let btnRowEdit = toolbar.find('.btn-row-edit')

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: tableData,
        columns: columns,
        // stateSave: true,
        order: [
            [0, 'dsc']
        ],
        pageLength: 50,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            topStart: toolbar,
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
        rowCallback: function (row, data) {
            if (data.is_active === 'false') {
                $(row).addClass('opacity-70');
            }
        },
        initComplete: function () {
            const api = this.api();
            const state = api.state.loaded()


            const colStatusIndex = 4;
            const colStatus = api.column(colStatusIndex);
            const colStatusStateValue = state?.columns[colStatusIndex].search.search ?? '';
            const elSelectStatus = ESR.View.select({
                value: colStatusStateValue,
                class: 'select-vizibility select-sm',
                placeholder: ESR.lang.visibility,
                options: [
                    {value: 1, label: ESR.lang.visible},
                    {value: 0, label: ESR.lang.hidden}
                ]
            }).on('change', function () {
                colStatus.search($(this).val(), {exact: true}).draw();
            });

            if (colStatusStateValue) {
                colStatus.search(colStatusStateValue, {exact: true}).draw();
            }

            $('.dt-layout-end').prepend(elSelectStatus)
        }
    });


    if (btnAdd.length) {
        // Handle add new project button click
        btnAdd.click((e) => {
            e.preventDefault();
            popupCreateUpdateFleetServicesType({}, ESR.lang.add);
        });

        $('body').on('click', (e) => {
            HelperTable.onSelectRow(e, table, btnRowEdit)
        });
    }

    // Handle row edit button click
    if (btnRowEdit.length) {
        btnRowEdit.click((e) => {
            e.preventDefault();
            const elRow = table.row('.selected');
            if (!elRow.node()) {
                return;
            }
            popupCreateUpdateFleetServicesType(elRow.data(), ESR.lang.save);
        });
    }

}